export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://office24.ssd.uz/api/v1'
export const URL = 'https://office24-backend-dev.ssd.uz'
export const LOGIN = '/auth/login'